import { Component, OnInit, Input } from "@angular/core";
import { SdpIcon } from "app/common/icon/models";
@Component({
	templateUrl: "./custom-user-email.component.html"
})
export class CustomUserEmailComponent {
	@Input()
	public username!: string;

	@Input()
	public isDisabled!: boolean;

	public readonly disabledIcon: SdpIcon.Icon = {
		type: "fa",
		name: "user-times",
		cssClass: "sdp-user-custom-disabled-icon"
	};

	constructor(
	) {
	}
}
